import { render, staticRenderFns } from "./ProfileAdress.vue?vue&type=template&id=4704a0b1&scoped=true&"
import script from "./ProfileAdress.vue?vue&type=script&lang=js&"
export * from "./ProfileAdress.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAdress.vue?vue&type=style&index=0&id=4704a0b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4704a0b1",
  null
  
)

export default component.exports